import { IAsset, IAssetDamage, IAssetService } from '../../asset.types';
import {
  Grid,
  Theme,
  Typography,
  Box,
  Paper
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MUIDataTableOptions } from "mui-datatables";
import { IAppState } from '../../../../../store';
import { getLocalizedDateFormat } from '../../../../../utils/localized.syntex';
import { DATE_TYPE, toCurrency } from '../../../../common/utils';
import { VehicleServiceStatus, VehicleServiceStatusValue, VehicleServiceType, VehicleServiceTypeValue } from '../../../../../reducers/fleet/types';
import { SelectableRows } from '../../../../common/NuvvenTable/types';
import { NuvvenTable } from '../../../../common/NuvvenTable/NuvvenTable';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    green: {
      color: "#00ff00"
    },
    header: {
      color: "rgb(45, 157, 184)",
      fontSize: 20
    },
    label: {
      color: "grey",
      fontSize: 12,
      fontWeight: 100,
      marginLeft: 20
    },
    paper: {
      color: theme.palette.text.secondary,
      padding: theme.spacing(1),
      textAlign: "center"
    },
    red: {
      color: "#ff0000"
    },
    root: {
      padding: theme.spacing(3)
    }
  })
);
interface IProps {
  asset: IAsset | undefined
}

export const ViewAssetDamages: FC<IProps> = ({ asset }) => {
  const userState = useSelector((state: IAppState) => state.userReducer);
  const { locale, currency } = userState.currentOrganisation;
  const { country } = userState.currentOrganisation.address;
  const classes = useStyles();
  const [assetDamages, setAssetDamages] = useState<IAssetDamage[]>([]);

  useEffect(() => {
    if (asset && asset.damages && asset.damages.length) {
      setAssetDamages(asset.damages);
    }
  }, [asset]);

  const columns = [
    {
      label: "Reference Number",
      name: "referenceNumber"
    },
    {
      label: "Circumstance",
      name: "circumstance"
    },
    {
      label: "Incident Date",
      name: "incidentDate",
      options: {
        customBodyRender: (value: string) => getLocalizedDateFormat(country, value, DATE_TYPE.EXPANDED)
      }
    },
    {
      label: "Total Expense",
      name: "totalExpense",
      options: {
        customBodyRender: (value: string) => toCurrency(parseInt(value || "0"), currency, locale)
      }
    },
    {
      label: "Status",
      name: "status",
      options: {
        customBodyRender: (value: VehicleServiceStatus) => VehicleServiceStatusValue[value]
      }
    }
  ];

  function Spacer() {
    return (
      <Grid item xs={12}>
        <Box mt={1} />
      </Grid>
    )
  }

  const options: MUIDataTableOptions = {
    selectableRows: SelectableRows.NONE,
    elevation: 0,
    onRowClick: (rowData: string[], rowMeta: { dataIndex: number }) => {
      if (rowData && rowData.length && asset && asset.damages && asset.damages.length) {
        const damageData = asset.damages[rowMeta.dataIndex];
        if (damageData) {
          window.open(`/update-asset-damage?id=${damageData.id}`, "_blank");
        }
      }
    },
  }

  return (
    <Grid container className={classes.root}>
      <Grid container item xs={12}>
        <Grid container item xs={12}>
          <Typography variant="subtitle1">DAMAGE HISTORY</Typography>
        </Grid>
        <Spacer />
        <Grid item xs={12}>
          {assetDamages && assetDamages.length > 0 ? (
            <Paper variant="outlined">
              <NuvvenTable
                title=""
                rows={assetDamages}
                columns={columns}
                options={options}
              />
            </Paper>
          ) : (
            <Grid xs={12} item>
              <Typography variant="h4">
                No Damages Data Found!
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}